import axios from "axios";
import { CronJob } from "cron";
import momentTZ from "moment-timezone";

// Interval runs every 5 minutes
const JOB_INTERVAL = "* */5 * * * *";

const REDIRECT_URL = "https://www.agridigital.io/scheduled-maintenance";

const MAINTENANCE_ENDPOINT =
  "https://prod-maintenance-content.s3.us-west-2.amazonaws.com/insight-maintenance.md";

const logMessage = (...message: string[]) => {
  const isDebugEnabled =
    localStorage &&
    typeof localStorage.getItem === "function" &&
    localStorage.getItem("debug") === "true";

  if (isDebugEnabled) {
    // tslint:disable-next-line
    console.log(...message);
  }
};

const job = new CronJob(
  JOB_INTERVAL,
  async () => {
    // Fetch maintenance
    logMessage("[DEBUG] - Fetching maintenance information");
    const shouldRedirect = await axios
      .get(MAINTENANCE_ENDPOINT)
      .then((response) => {
        const headers = response.headers;
        const ZONE = "Australia/Sydney";

        const currentTime = momentTZ(headers.date).tz(ZONE);
        const startDate = momentTZ(headers["x-amz-meta-startdate"]).tz(ZONE);
        const endDate = momentTZ(headers["x-amz-meta-enddate"]).tz(ZONE);

        // Return true if currently inside start and end date
        if (currentTime >= startDate && currentTime <= endDate) {
          return true;
        }
      })
      .catch(logMessage);

    // Allow users to override maintenance redirection
    const overrideRedirect =
      localStorage &&
      typeof localStorage.getItem === "function" &&
      localStorage.getItem("override-maintenance") === "true";

    if (shouldRedirect && overrideRedirect) {
      logMessage("[DEBUG] - Redirecting overriden by user");
    }

    if (shouldRedirect && !overrideRedirect) {
      job.stop();
      window.location.href = REDIRECT_URL;
    }
  },
  null,
  false,
  "Australia/Sydney",
  null,
  true
);

export default job;
